import React from 'react';
import { PhoneIcon, StarIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="bg-navy pt-4 pb-6 px-4 md:pt-6 md:pb-8 relative z-20" data-id="element-22">
      <div className="max-w-7xl mx-auto" data-id="element-23">
        {/* Navigation / Header */}
        <div className="flex flex-row justify-between items-center mb-3 md:mb-4 gap-3 px-2 md:px-0" data-id="element-24">
          <img src="https://cdn.magicpatterns.com/uploads/opXSaFkmappgfGitP8aDsi/logo-text_-_Edited.png" alt="The Founders Law - Personal Injury Trial Attorneys" className="h-8 md:h-10 w-auto" data-id="element-25" />

          <a href="tel:7862852768" onClick={() => {
          if (window.fbq) window.fbq('track', 'Contact');
        }} className="flex items-center gap-1.5 text-white hover:text-orange transition-colors font-bold text-sm md:text-base" data-id="element-26">
            <PhoneIcon className="w-3.5 h-3.5 md:w-4 md:h-4" data-id="element-27" />
            LLAME AHORA
          </a>
        </div>

        {/* Hero Content */}
        <div className="text-center max-w-4xl mx-auto space-y-4 md:space-y-5" data-id="element-28">
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-black text-white leading-snug max-w-3xl mx-auto" data-id="element-29">
            Hemos Recuperado Más de
            <br data-id="element-30" />
            <span className="text-orange" data-id="element-31">$300 Millones</span>
            <br data-id="element-32" />
            ¿Cuánto Vale Su Caso de Accidente?
          </h1>

          <p className="text-base md:text-lg text-gray-400 font-medium max-w-2xl mx-auto" data-id="element-33">
            Comience su evaluación GRATUITA hoy. Solo cobramos si ganamos.
          </p>

          <div className="flex flex-col items-center pt-1" data-id="element-34">
            <a href="tel:7862852768" onClick={() => {
            if (window.fbq) window.fbq('track', 'Contact');
          }} className="w-full md:w-auto max-w-md bg-green hover:bg-green-hover text-white rounded-xl p-3 md:px-10 md:py-4 flex flex-col items-center justify-center transition-all transform hover:scale-105 shadow-lg hover:shadow-green/20" data-id="element-35">
              <div className="flex items-center gap-2 text-lg md:text-xl font-black mb-0.5" data-id="element-36">
                <PhoneIcon className="w-5 h-5 md:w-6 md:h-6 fill-current" data-id="element-37" />
                LLAME AHORA
              </div>
              <span className="text-xs md:text-sm font-bold opacity-90 tracking-wide" data-id="element-38">
                PARA UNA RESOLUCIÓN RÁPIDA
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>;
}